import { Button } from 'base/ui/button';
import { Dialog } from 'base/ui/dialog';
import { TextRegular, TextRegularLight } from 'base/ui/typography';
import React from 'react';

export function ConfirmDeleteDialog({
  name,
  doDelete,
  onCancel,
}: {
  name: string;
  doDelete: () => Promise<unknown>;
  onCancel: () => void;
}) {
  const [deleting, setDeleting] = React.useState(false);
  const onConfirm = () => {
    if (deleting) return;
    setDeleting(true);
    doDelete().finally(() => setDeleting(false));
  };

  return (
    <Dialog
      title="Delete this project?"
      onClose={onCancel}
      buttons={
        <>
          <Button label="Cancel" onClick={onCancel} size="large" />
          <Button
            loading={deleting}
            variant="primary"
            background="negative"
            label="Delete"
            onClick={onConfirm}
            size="large"
          />
        </>
      }
    >
      <TextRegularLight>
        You are about to delete <TextRegular tag="span">{name}</TextRegular>.
      </TextRegularLight>
      <TextRegularLight>
        Once deleted, this project will no longer be accessible.
      </TextRegularLight>
    </Dialog>
  );
}
